"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const canvas_1 = require("canvas");
const d3_1 = require("d3");
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const Axis_1 = __importDefault(require("../../../components/Axis"));
const Bars_1 = __importDefault(require("../../../components/Bars"));
const EllipsizedLabel_1 = __importDefault(require("../../../components/EllipsizedLabel"));
const Gridlines_1 = __importDefault(require("../../../components/Gridlines"));
const LabelContainer_1 = __importDefault(require("../../../components/LabelContainer"));
const Legend_1 = __importDefault(require("../../../components/Legend"));
const Tooltip_1 = __importDefault(require("../../../components/Tooltip"));
const TooltipContent_1 = __importDefault(require("../../../components/Tooltip/TooltipContent"));
const utilities_1 = require("../../../utilities");
const colors_1 = require("../../../utilities/colors");
const constants_1 = require("../../../utilities/constants");
const types_1 = require("../../../utilities/types");
const constants_2 = require("../../BarChart/constants");
const model_1 = require("../model");
const styles_module_css_1 = __importDefault(require("../styles.module.css"));
const canvas = (0, canvas_1.createCanvas)(0, 0);
const GroupedBarChart = _ref => {
  let {
    axisTextColor,
    barHeight: _barHeight,
    chartHeight,
    chartWidth,
    categories,
    data,
    date,
    floatingAxis,
    fontSize,
    gridColor,
    groups,
    groupSpacing,
    height,
    hideAxis,
    hideBottomXTicks,
    hideGridlines,
    hideLegend,
    hideTooltip,
    hideTooltipYear,
    hideTopXTicks,
    hideValueLabel,
    metrics,
    selectedKeys,
    throttledSetTooltip,
    tooltip,
    // width,
    xAxisTicks
  } = _ref;
  const previousValues = (0, react_1.useRef)(new Array(groups.length).fill(null).map(() => new Array(categories.length).fill(null)));
  if (categories.length === 0 || metrics.length === 0 || groups.length === 0 || chartWidth == null) {
    return react_1.default.createElement("div", null);
  }
  const chartTopPadding = 10;
  const chartBottomPadding = 10;
  const labelPadding = 10;
  const labelLeftPadding = 3;
  const containerRef = (0, react_1.createRef)();
  const ctx = canvas.getContext('2d');
  const textWidth = text => {
    if (lodash_1.default.isNil(text)) {
      return 0;
    }
    ctx.font = `${fontSize}px ${constants_1.FONT_FAMILY}`;
    const {
      actualBoundingBoxLeft,
      actualBoundingBoxRight
    } = ctx.measureText(text);
    return actualBoundingBoxLeft + actualBoundingBoxRight;
  };
  const getMaxBarLabel = function (extractedDatasets, floatingAxis, date) {
    if (floatingAxis) {
      const dateFilteredValues = extractedDatasets.map(dat => ({
        value: dat.data.filter(dataset => date === dataset.key)[0].value,
        type: dat.data.filter(dataset => date === dataset.key)[0].y_type
      }));
      return (0, lodash_1.default)(dateFilteredValues)
      // eslint-disable-next-line camelcase
      .map(_ref2 => {
        let {
          value,
          y_type
        } = _ref2;
        const format = (0, utilities_1.valueFormat)({
          params: {
            format: y_type
          }
        });
        const fortmattedLabel = value !== null ? format(value) : 'no data';
        return textWidth(fortmattedLabel);
      }).max();
    }
    const bars = extractedDatasets.map(data =>
    // eslint-disable-next-line camelcase
    data.data.map(_ref3 => {
      let {
        value,
        y_type
      } = _ref3;
      return {
        value,
        y_type
      };
    }));
    return (0, lodash_1.default)(bars).flatten()
    // eslint-disable-next-line camelcase
    .map(_ref4 => {
      let {
        value,
        y_type
      } = _ref4;
      const format = (0, utilities_1.valueFormat)({
        params: {
          format: y_type
        }
      });
      const fortmattedLabel = value !== null ? format(value) : 'no data';
      return textWidth(fortmattedLabel);
    }).max();
  };
  const maxBarLabel = getMaxBarLabel(data, floatingAxis, date);
  const maximum = (0, model_1.maxBar)(data, floatingAxis, date);
  const minimum = (0, model_1.minBar)(data, floatingAxis, date);
  const maxLabel = (0, lodash_1.default)(groups).map(_ref5 => {
    let {
      label
    } = _ref5;
    return textWidth(label);
  }).max() + labelPadding;
  const availableBarWidth = chartWidth - maxLabel - (maximum > 0 ? maxBarLabel : 0) - (minimum < 0 ? maxBarLabel : 0);
  const xScale = (0, d3_1.scaleLinear)().domain([Math.min(minimum, 0), Math.max(maximum, 0)]).range([0, availableBarWidth]).nice();
  let defaultTickCount = 5;
  if (availableBarWidth < 150) {
    defaultTickCount = 2;
  } else if (availableBarWidth < 300) {
    defaultTickCount = 3;
  }
  const zeroTickPosition = maxLabel + xScale(0) + (minimum < 0 ? maxBarLabel : 0);
  const topAxisHeight = hideAxis || hideTopXTicks ? 0 : fontSize;
  const bottomAxisHeight = hideAxis || hideBottomXTicks ? 0 : fontSize;
  const legendWidth = hideLegend ? 0 : lodash_1.default.sum(categories.map(_ref6 => {
    let {
      label
    } = _ref6;
    return fontSize + 4 + textWidth(label) + 20;
  }));
  const legendHeight = fontSize * 2.5 * Math.ceil(legendWidth / chartWidth);
  let barHeight = _barHeight;
  if (height) {
    const availableBarsHeight = height - chartTopPadding - legendHeight - topAxisHeight - groupSpacing - bottomAxisHeight - chartBottomPadding;
    barHeight = Math.floor(availableBarsHeight / (groups.length * categories.length));
  }
  const barsHeight = groups.length * (categories.length * barHeight + groupSpacing) - groupSpacing;
  const svgHeight = chartTopPadding + legendHeight + topAxisHeight + barsHeight + bottomAxisHeight + chartBottomPadding;
  const minChartHeight = svgHeight;
  const barArray = lodash_1.default.map(groups, (_ref7, i) => {
    let {
      id: groupID,
      key: groupKey
    } = _ref7;
    return (0, lodash_1.default)(categories).map((_ref8, categoryIndex) => {
      let {
        id: categoryID,
        key: categoryKey,
        color,
        label: categoryLabel
      } = _ref8;
      const barColor = color || colors_1.DEFAULT_COLORS[categoryIndex % colors_1.DEFAULT_COLORS.length];
      const {
        metrics: metricIDs = [{}]
      } = lodash_1.default.find(metrics, _ref9 => {
        let {
          group,
          category
        } = _ref9;
        return group === groupID && category === categoryID;
      }) || {};
      return metricIDs.map(_ref10 => {
        let {
          id: metricID
        } = _ref10;
        const {
          data: dataset = [],
          // eslint-disable-next-line camelcase
          y_type,
          // eslint-disable-next-line camelcase
          x_type
        } = data.find(_ref11 => {
          let {
            id
          } = _ref11;
          return id === metricID;
        }) || {};
        const ds = dataset.find(_ref12 => {
          let {
            key
          } = _ref12;
          return selectedKeys.length ? [groupKey, categoryKey].includes(key) : key === date;
        }) || {};
        const {
          value = null
        } = ds;
        const previousValue = previousValues.current[i][categoryIndex];
        const signChange = Number.isFinite(value) && Number.isFinite(previousValue) && value * previousValue < 0 || !Number.isFinite(value) && previousValue < 0 || !Number.isFinite(previousValue) && value < 0;
        previousValues.current[i][categoryIndex] = value;
        return {
          width: value === null ? 0 : xScale(value) - xScale(0),
          x: zeroTickPosition,
          y: i * (groupSpacing + categories.length * barHeight) + categoryIndex * barHeight + topAxisHeight + chartTopPadding,
          height: barHeight,
          color: barColor,
          value,
          y_type,
          x_type,
          categoryLabel,
          signChange,
          key: i * categories.length + categoryIndex
        };
      });
    }).flatten().value();
  });
  const grid = xScale.ticks(xAxisTicks || defaultTickCount);
  const axisType = lodash_1.default.first(data).y_type; // Use the ytype of the first dataset for axis
  const axisFormat = (0, utilities_1.valueFormat)({
    params: {
      format: axisType
    }
  });
  const ticks = grid.map(value => ({
    data: value,
    point: xScale(value) + maxLabel + (minimum < 0 ? maxBarLabel : 0),
    strokeWidth: 1
  }));
  return react_1.default.createElement("div", {
    style: {
      height: chartHeight,
      minHeight: minChartHeight,
      overflow: 'visible',
      position: 'relative',
      width: '100%'
    },
    ref: containerRef,
    className: "inner-chart-content"
  }, !hideLegend && react_1.default.createElement(Legend_1.default, {
    ...{
      categories,
      fontSize
    }
  }), react_1.default.createElement("svg", {
    style: {
      overflow: 'visible'
    }
  }, !hideTopXTicks && !hideAxis && react_1.default.createElement(Axis_1.default, {
    position: "top",
    chartWidth: availableBarWidth,
    chartHeight: svgHeight,
    fontSize: fontSize,
    textColor: (0, colors_1.parseColor)(axisTextColor, constants_2.DEFAULT_TEXT_COLOR),
    ticks: ticks,
    formatter: value => axisFormat(value, {
      ticks: grid
    })
  }), !hideBottomXTicks && !hideAxis && react_1.default.createElement(Axis_1.default, {
    position: "bottom",
    chartWidth: availableBarWidth,
    chartHeight: svgHeight,
    fontSize: fontSize,
    textColor: (0, colors_1.parseColor)(axisTextColor, constants_2.DEFAULT_TEXT_COLOR),
    ticks: ticks,
    formatter: value => axisFormat(value, {
      ticks: grid
    })
  }), !hideGridlines && !hideAxis && react_1.default.createElement(Gridlines_1.default, {
    orientation: "vertical",
    range: [topAxisHeight, topAxisHeight + barsHeight + bottomAxisHeight],
    strokeWidth: 1,
    gridColor: (0, colors_1.parseColor)(gridColor, constants_2.DEFAULT_TEXT_COLOR),
    ticks: ticks
  }), !hideValueLabel && react_1.default.createElement(LabelContainer_1.default, {
    labels: barArray.map((group, i) =>
    // eslint-disable-next-line camelcase
    group.map((_ref13, j) => {
      let {
        value,
        width: barWidth,
        height,
        y_type,
        x,
        y
      } = _ref13;
      const format = (0, utilities_1.valueFormat)({
        params: {
          format: y_type,
          basic: true
        }
      });
      const fortmattedLabel = value !== null ? format(value) : 'no data';
      return {
        x: x + barWidth + labelLeftPadding - (barWidth < 0 ? textWidth(fortmattedLabel) + 2 * +labelLeftPadding : 0),
        y: y + constants_1.FONT_VERTICAL_CENTER_OFFSET_RATIO * fontSize + height / 2,
        key: i * group.length + j,
        content: value,
        style: {
          fill: (0, colors_1.parseColor)(constants_2.DEFAULT_TEXT_COLOR),
          fontWeight: 400
        }
      };
    })).flat(),
    formatter: (staticValue, key) => {
      // eslint-disable-next-line camelcase
      const {
        y_type
      } = barArray[Math.floor(key / categories.length)][key % categories.length];
      const format = (0, utilities_1.valueFormat)({
        params: {
          format: y_type,
          basic: true
        }
      });
      return staticValue ? format(staticValue) : 'no data';
    }
  }), react_1.default.createElement(Bars_1.default, {
    bars: barArray.flat(),
    onMouseOver: (event, i) => {
      const datum = barArray.flat()[i];
      if (!datum) {
        return;
      }
      const x = zeroTickPosition + datum.width / 2; // * (datum.value > 0 ? 1 : -1);
      const y = datum.y + datum.height / 2 + chartTopPadding + legendHeight;
      const direction = 'below';
      throttledSetTooltip({
        position: {
          x,
          y
        },
        group: groups[Math.floor(i / categories.length)].label,
        category: categories[i % categories.length].label,
        value: datum.value,
        color: datum.color,
        x_type: datum.x_type,
        y_type: datum.y_type,
        direction
      });
    },
    onMouseOut: () => {
      throttledSetTooltip({
        position: {
          x: null,
          y: null
        }
      });
    }
  }), react_1.default.createElement("g", {
    className: styles_module_css_1.default['group-labels']
  }, react_1.default.createElement(LabelContainer_1.default, {
    labels: groups.map((_ref14, i) => {
      let {
        label
      } = _ref14;
      return {
        x: 0,
        y: (barHeight * categories.length + groupSpacing) * i + barHeight * categories.length / 2 + topAxisHeight + chartTopPadding + constants_1.FONT_VERTICAL_CENTER_OFFSET_RATIO * fontSize,
        key: label,
        content: react_1.default.createElement(EllipsizedLabel_1.default, {
          dominantBaseline: "hanging",
          label: label,
          fontSize: fontSize,
          maxWidth: maxLabel,
          maxLines: 1
        }),
        style: {
          fill: (0, colors_1.parseColor)(constants_2.DEFAULT_TEXT_COLOR),
          fontWeight: 400
        }
      };
    })
  }))), !hideTooltip && tooltip.position.x !== null && tooltip.position.y !== null && react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-container']
  }, react_1.default.createElement(Tooltip_1.default, {
    direction: tooltip.direction,
    ...tooltip.position,
    width: chartWidth
  }, react_1.default.createElement(TooltipContent_1.default, {
    title: react_1.default.createElement("div", null, `${tooltip.group},`, react_1.default.createElement("span", {
      style: {
        color: tooltip.color
      }
    }, ` ${tooltip.category}`)),
    subtitle: hideTooltipYear ? undefined : (0, utilities_1.valueFormat)({
      params: {
        format: tooltip.x_type
      }
    })(date),
    value: tooltip.value,
    type: tooltip.y_type,
    color: tooltip.color
  }))));
};
GroupedBarChart.propTypes = {
  /** Height to draw the chart. */
  chartHeight: prop_types_1.number,
  /** Width to draw the chart. Will fill container if unset. */
  chartWidth: prop_types_1.number,
  /** Height to draw the chart. */
  height: prop_types_1.number,
  /** Width to draw the chart. Will fill container if unset. */
  width: prop_types_1.number,
  /*
   * Height of the bars in pixels
   */
  barHeight: prop_types_1.number,
  /**
   * IDs and labels of groups
   */
  groups: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired
  })).isRequired,
  /**
   * IDs, labels and colors of categories
   */
  categories: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    color: prop_types_1.string
  })),
  /**
   * Defines which group and category each data belongs to. Allows override of name and color.
   */
  metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    group: prop_types_1.string.isRequired,
    category: prop_types_1.string.isRequired,
    metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      name: prop_types_1.string,
      id: prop_types_1.string.isRequired,
      color: prop_types_1.string
    }))
  })).isRequired,
  /**
   * Data for the chart
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * date react state passthrough; controls which date to read bar lengths from
   */
  date: prop_types_1.string.isRequired,
  /**
   * Removes value labels from the end of bars
   */
  floatingAxis: prop_types_1.bool,
  /**
   * Removes the axis labels and gridlines
   */
  hideValueLabel: prop_types_1.bool,
  /**
   * Removes the axis labels and gridlines
   */
  hideAxis: prop_types_1.bool,
  /**
   * Removes the axis gridlines
   */
  hideGridlines: prop_types_1.bool,
  /**
   * Removes the legend
   */
  hideLegend: prop_types_1.bool,
  /**
   * Specifies the desired number of gridlines. d3 will then modify this value
   * to make the lines look nice.
   */
  xAxisTicks: prop_types_1.number,
  /**
   * tooltip react state passthrough; this object contains the fields used to create the tooltip
   * Includes position info (x and y coordinates), group name, category name, bar value,
   * bar color, bar data type (y_type), and direction.
   */
  tooltip: (0, prop_types_1.shape)(),
  /*
   * react setState passthrough; allows the chart to update the above tooltip information
   */
  throttledSetTooltip: prop_types_1.func,
  /**
   * Prevents any tooltips from appearing
   */
  hideTooltip: prop_types_1.bool,
  /**
   * Changes the labels above and below the axis gridlines to the specified color.
   */
  axisTextColor: prop_types_1.string,
  /**
   * Changes the axis gridlines to the specified color
   */
  gridColor: prop_types_1.string,
  /**
   * Removes bottom axis labels
   */
  hideBottomXTicks: prop_types_1.bool,
  /**
   * Removes top axis labels
   */
  hideTopXTicks: prop_types_1.bool,
  /**
   * Hides the year from all tooltips
   */
  hideTooltipYear: prop_types_1.bool,
  /**
   * sets axis, label, and group font sizes
   */
  fontSize: prop_types_1.number,
  /*
   * sets spacing between bar groups
   */
  groupSpacing: prop_types_1.number,
  /**
   * Duration (in ms) of transitions
   */
  selectedKeys: (0, prop_types_1.arrayOf)(prop_types_1.string),
  /**
   * Duration (in ms) of transitions
   */
  transitionDuration: prop_types_1.number
};
exports.default = GroupedBarChart;